import SectionCard from "../../components/SectionCard/SectionCard";
import { ProtectedElement } from "../ProtectedElement/ProtectedElement";
import { perms } from "../../api/codes";

const CardsPage = ({ items }) => {
  return (
    <div className="cards">
      {items
        .slice() // Create a copy to avoid mutating the original array
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((c, idx) => {
          return (
            <ProtectedElement
              key={idx}
              module={c?.module}
              perm={perms.viewList}
            >
              <SectionCard Icon={c.icon} title={c.title} href={c.path} />
            </ProtectedElement>
          );
        })}
    </div>
  );
};

export default CardsPage;
